export default "dist/images/block-feature-overlap-shape4.c8294ec.png";